import styled from 'styled-components';
import { Form, Typography } from 'antd';

export const RobotNameText = styled(Typography.Text)`
  &.ant-typography {
    font-size: ${({ theme: { kcc } }): number => kcc.typography.FONT_SIZE.LG}px;
    font-weight: ${({ theme: { kcc } }): number => kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
  }
`;

export const RobotTypeText = styled(Typography.Text)`
  &.ant-typography {
    font-size: ${({ theme: { kcc } }): number => kcc.typography.FONT_SIZE.SM}px;
    color: ${({ theme: { kcc } }): string => kcc.colors.TEXT_SECONDARY};
  }
`;

export const IconContainer = styled.div`
  width: ${({ theme: { kcc } }): number => kcc.size.S300}px;
  height: ${({ theme: { kcc } }): number => kcc.size.S300}px;
`;

export const ScheduleFormInfoFormItem = styled(Form.Item)`
  margin: 0;
  width: 100%;

  .ant-form-item-explain-error {
    position: absolute;
    margin-top: 2px;
  }

  input::placeholder {
    color: ${({ theme: { kcc } }): string => kcc.colors.TEXT_PLACEHOLDER};
  }

  .schedule-frequency-active-border:not(.ant-select-disabled),
  .schedule-select-active-border:not(.ant-select-disabled) {
    .ant-select-selector {
      border-color: ${({ theme: { kcc } }): string => kcc.colors.BORDER_ACTIVE};
    }
  }

  .ant-input-number-affix-wrapper:not(.ant-input-number-disabled) {
    border-color: ${({ theme: { kcc } }): string => kcc.colors.BORDER_ACTIVE};
  }

  .ant-picker {
    border-color: ${({ theme: { kcc } }): string => kcc.colors.BORDER_SECONDARY};

    .ant-picker-suffix {
      width: ${({ theme: { kcc } }): number => kcc.size.S250}px;
      height: ${({ theme: { kcc } }): number => kcc.size.S250}px;

      svg {
        width: ${({ theme: { kcc } }): number => kcc.size.S250}px;
        height: ${({ theme: { kcc } }): number => kcc.size.S250}px;
      }
    }
  }

  .ant-input-status-success,
  .ant-picker-status-success,
  .schedule-picker-active-border:not(.ant-picker-disabled) {
    border-color: ${({ theme: { kcc } }): string => kcc.colors.BORDER_ACTIVE} !important;
  }

  .ant-select-arrow {
    width: ${({ theme: { kcc } }): number => kcc.size.S250}px;

    svg {
      width: ${({ theme: { kcc } }): number => kcc.size.S250}px;
    }
  }
`;
